<form name="userProfileForm" [formGroup]="userProfileForm" novalidate>

  <div class="row pt-4">
    <div class="col-md-12">
      <h4 class="ms-2">
        <span>Vet</span>
      </h4>
    </div>
  </div>

  <div class="row">
    <div class="col-md-6">
      <div class="form-group row mt-3">
        <label class="col-sm-4 w-100 col-form-label" for="firstName">First Name</label>
        <div class="col-sm-8 w-100">
          <div class="row m-0">
            <div class="col-3 p-0">
              <select class="form-control" formControlName="gender" disabled>
                <option value="dr">Dr</option>
              </select>
            </div>
            <div class="col-9 ps-1">
              <input type="text"
                     id="firstName"
                     class="form-control"
                     formControlName="firstName"
                     readonly />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-6">
      <div class="form-group row mt-3">
        <label class="col-sm-4 w-100 col-form-label" for="suffix">Suffix</label>
        <div class="col-sm-8 w-100">
          <input type="text"
                 class="form-control"
                 id="suffix"
                 formControlName="suffix"
                 readonly />
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-6">
      <div class="form-group row mt-3">
        <label class="col-sm-4 w-100 col-form-label" for="lastName">Last Name</label>
        <div class="col-sm-8 w-100">
          <input type="text"
                 id="lastName"
                 formControlName="lastName"
                 class="form-control"
                 readonly />
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group row mt-3">
        <label class="col-sm-4 w-100 col-form-label" for="degree">Degree</label>
        <div class="col-sm-8 w-100">
          <input type="text"
                 class="form-control"
                 id="degree"
                 formControlName="degree"
                 readonly />
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <div class="form-group row mt-3">
        <label class="col-sm-2 w-100 col-form-label" for="accreditation">Accreditation</label>
        <div class="col-sm-10 w-100">
          <input type="text"
                 class="form-control"
                 formControlName="accreditation"
                 readonly />
        </div>
      </div>
    </div>
  </div>

  <div class="row pt-4">
    <div class="col-md-12">
      <h4 class="ms-2">
        <span>Clinic Detail</span>
      </h4>
    </div>
  </div>

  <div class="row">
    <div class="col-md-6">
      <div class="form-group row mt-3">
        <label class="col-sm-4 w-100 col-form-label" for="ClinicName">Clinic Name</label>
        <div class="col-sm-8 w-100">
          <input id="ClinicName"
                 type="text"
                 class="form-control"
                 formControlName="organisation"
                 readonly />
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group row mt-3">
        <label class="col-sm-4 w-100 col-form-label" for="email">Email</label>
        <div class="col-sm-8 w-100">
          <input type="text"
                 formControlName="email"
                 id="email"
                 class="form-control"
                 readonly />
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-6">
      <div class="form-group row mt-3">
        <label class="col-sm-4 w-100 col-form-label" for="ClinicId">Clinic Id</label>
        <div class="col-sm-8 w-100">
          <input id="ClinicId"
                 type="text"
                 class="form-control"
                 formControlName="organisationID"
                 readonly />
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group row mt-3">
        <label class="col-sm-4 w-100 col-form-label" for="website">Website</label>
        <div class="col-sm-8 w-100">
          <input id="websiteUrl"
                 type="text"
                 formControlName="websiteUrl"
                 class="form-control"
                 readonly />
        </div>
      </div>
    </div>
  </div>

  <!-- Address & Phone -->
  <div class="row">
    <div class="col-md-6">
      <div class="form-group row mt-3">
        <label class="col-sm-4 w-100 col-form-label" for="address">Address</label>
        <div class="col-sm-8 w-100">
          <input type="text"
                 id="address"
                 class="form-control"
                 formControlName="address"
                 readonly />
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group row mt-3">
        <label class="col-sm-4 w-100 col-form-label" for="phoneNumber">Office Phone 1</label>
        <div class="col-sm-8 w-100">
          <input type="text"
                 formControlName="phoneNumber"
                 id="phoneNumber"
                 class="form-control"
                 readonly />
        </div>
      </div>
    </div>
  </div>

  <!-- City & Contact -->
  <div class="row">
    <div class="col-md-6">
      <div class="form-group row mt-3">
        <label class="col-sm-4 w-100 col-form-label" for="city">City/Suburb</label>
        <div class="col-sm-8 w-100">
          <input id="city"
                 class="form-control"
                 type="text"
                 formControlName="city"
                 readonly />
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group row mt-3">
        <label class="col-sm-4 w-100 col-form-label" for="contactNumber1">Contact Number 1</label>
        <div class="col-sm-8 w-100">
          <input type="text"
                 formControlName="contactNumber1"
                 id="contactNumber1"
                 class="form-control"
                 readonly />
        </div>
      </div>
    </div>
  </div>

  <!-- State & Contact 2 -->
  <div class="row">
    <div class="col-md-6">
      <div class="form-group row mt-3">
        <label class="col-sm-4 w-100 col-form-label" for="stateName">State/Province</label>
        <div class="col-sm-8 w-100">
          <input type="text"
                 id="stateName"
                 class="form-control"
                 formControlName="stateName"
                 readonly />
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group row mt-3">
        <label class="col-sm-4 w-100 col-form-label" for="contactNumber2">Contact Number 2</label>
        <div class="col-sm-8 w-100">
          <input type="text"
                 formControlName="contactNumber2"
                 id="contactNumber2"
                 class="form-control"
                 readonly />
        </div>
      </div>
    </div>
  </div>

  <!-- Post Code -->
  <div class="row">
    <div class="col-md-6">
      <div class="form-group row mt-3">
        <label class="col-sm-4 w-100 col-form-label" for="postCode">Post/Zip Code</label>
        <div class="col-sm-8 w-100">
          <input type="text"
                 id="postCode"
                 class="form-control"
                 formControlName="postCode"
                 readonly />
        </div>
      </div>
    </div>
  </div>

  <!-- Country -->
  <div class="row">
    <div class="col-md-6">
      <div class="form-group row mt-3">
        <label class="col-sm-4 w-100 col-form-label" for="countryName">Country</label>
        <div class="col-sm-8 w-100">
          <input type="text"
                 formControlName="countryName"
                 id="countryName"
                 class="form-control"
                 readonly />
        </div>
      </div>
    </div>
  </div>

  <!-- DICOM -->
  <div class="row">
    <div class="col-md-6">
      <div class="form-group row mt-3">
        <label class="col-sm-4 w-100 col-form-label" for="DICOM">DICOM Device</label>
        <div class="col-sm-8 w-100">
          <select class="form-control"
                  id="DICOM"
                  disabled>
            <option value="0">Some DICOM Option</option>
          </select>
        </div>
      </div>
    </div>
  </div>

  <!-- Tracking URL -->
  <div class="row">
    <div class="col-md-12">
      <div class="form-group row mt-3">
        <label class="col-sm-2 w-100 col-form-label" for="trackingURL">Tracking URL</label>
        <div class="col-sm-10 w-100">
          <input type="text"
                 class="form-control"
                 formControlName="trackingURL"
                 id="trackingURL"
                 readonly />
        </div>
      </div>
    </div>
  </div>

</form>
